var map = {
	"./code.png": 36284,
	"./excel.png": 60066,
	"./ico_excel.png": 60016,
	"./ico_img.png": 88292,
	"./ico_no.png": 30332,
	"./ico_pdf.png": 74815,
	"./ico_ppt.png": 5497,
	"./ico_rar.png": 26326,
	"./ico_txt.png": 21077,
	"./ico_video.png": 68452,
	"./ico_word.png": 205,
	"./img.png": 83694,
	"./music.png": 11938,
	"./no.png": 43830,
	"./pdf.png": 12705,
	"./ppt.png": 86015,
	"./rar.png": 44668,
	"./txt.png": 79667,
	"./video.png": 74018,
	"./word.png": 42731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10352;